import {
    Background,
    BackgroundColor,
    Container,
    ContainerVariant,
    Spacer,
    SpacerVariant,
    backgroundOptions,
    spacerOptions,
} from "../components/layout"
import { Repeater, types } from "react-bricks/frontend"

import { CenterTextProps } from "../text/CenterText"
import FixedWidthSlider from "../components/slider/fixed-width-slider"
import { IconTextProps } from "./IconText"
import React from "react"
import { TypographyColor } from "../components/typography"

interface IconTextSliderProps {
    background: { color: BackgroundColor } | BackgroundColor
    repeater?: {
        id: string
        props: IconTextProps
        type: "IconText"
    }[]
    spacerTop: boolean
    spacerBottom: boolean
    variantTop?: SpacerVariant
    variantBottom?: SpacerVariant
}

const IconTextSlider: types.Brick<IconTextSliderProps> = ({
    background,
    repeater,
    spacerTop,
    spacerBottom,
    variantTop,
    variantBottom,
}) => {
    const bgColor = typeof background === "object" ? background.color : background

    return (
        <Background color={bgColor}>
            <Spacer variant={!spacerTop ? SpacerVariant.None : variantTop} />
            <Repeater
                propName="centerText"
                renderWrapper={children => <Container>{children}</Container>}
                itemProps={
                    {
                        color:
                            bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                                ? TypographyColor.White
                                : TypographyColor.Darkgrey,
                    } as CenterTextProps
                }
            />
            <FixedWidthSlider length={repeater?.length || 0} bgColor={bgColor}>
                <Repeater
                    propName="repeater"
                    itemProps={
                        {
                            variant: ContainerVariant.Small,
                            color:
                                bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                                    ? TypographyColor.White
                                    : undefined,
                        } as IconTextProps
                    }
                />
            </FixedWidthSlider>
            <Spacer variant={!spacerBottom ? SpacerVariant.None : variantBottom} />
        </Background>
    )
}

IconTextSlider.schema = {
    name: "IconTextSlider",
    label: "Icon Text Slider",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/IconTextSlider.png`,
    repeaterItems: [
        {
            name: "centerText",
            items: [
                {
                    type: "CenterText",
                    label: "Text",
                    max: 1,
                },
            ],
        },
        {
            name: "repeater",
            items: [
                {
                    type: "IconText",
                    label: "Icon Text",
                    min: 0,
                },
                {
                    type: "StarsText",
                    label: "Stars Text",
                    min: 0,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "background",
            label: "Background",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: backgroundOptions,
                display: types.OptionsDisplay.Color,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantTop",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerTop === true,
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Boolean,
                },
                {
                    name: "variantBottom",
                    label: "Spacer Variant",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptions,
                        display: types.OptionsDisplay.Select,
                    },
                    show: props => props.spacerBottom === true,
                },
            ],
        },
    ],
    getDefaultProps: (): IconTextSliderProps => ({
        background: { color: BackgroundColor.White },
        spacerTop: true,
        spacerBottom: true,
        variantTop: SpacerVariant.Base,
        variantBottom: SpacerVariant.Base,
    }),
}

export default IconTextSlider
